import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextFieldProps,
} from '@mui/material';
import { VisibilityOff, Visibility } from '@mui/icons-material';
import { useLogic } from './logic';
import { Controller, FieldValues, Path } from 'react-hook-form';

interface Props<T> extends Omit<TextFieldProps, 'name'> {
  name: Path<T> | string;
  control?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export function PasswordInputField<T extends FieldValues = never>({
  name,
  control,
  id,
  label,
  placeholder,
  required = false,
}: Props<T>) {
  const { showPassword, handleClickShowPassword, handleMouseDownPassword } =
    useLogic();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { invalid, error } }) => {
        return (
          <FormControl variant="outlined" fullWidth>
            {label && (
              <InputLabel htmlFor={id} required={required}>
                {label}
              </InputLabel>
            )}
            <OutlinedInput
              {...field}
              id={id}
              name={name}
              type={showPassword ? 'text' : 'password'}
              required={required}
              error={invalid}
              placeholder={placeholder}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              label={label}
            />
            <FormHelperText error>{error ? error?.message : ''}</FormHelperText>
          </FormControl>
        );
      }}
    />
  );
}
